export default __webpack_public_path__ + "static/OpenSans-Semibold-fb9fdde61d631c58d46cbe6f8eaa7197.woff2";